// extracted by mini-css-extract-plugin
module.exports = {"item":"i_Qh","label":"i_Qi","sub-title":"i_Qj","value":"i_Qk","text":"i_Ql","icon":"i_Qm","grow":"i_Qn"};